const { get } = require("lodash");
const { hostHeader, protocolHeader } = require("./http/HttpRequest");

const environmentVariables = () => {
  if (isDevEnvironment()) return devEnvironmentVariables();
  if (isProductionEnvironment()) return productionEnvironmentVariables();
  return stagingEnvironmentVariables();
};

const environmentAliases = () => {
  if (isDevEnvironment()) return devEnvironmentAliases();
  if (isProductionEnvironment()) return productionEnvironmentAliases();
  return stagingEnvironmentAliases();
};

const isDevEnvironment = () => process.env.NODE_ENV === "development";

const isStagingEnvironment = () => process.env.NEXT_PUBLIC_SERVER === "staging";

const isProductionEnvironment = () =>
  process.env.NEXT_PUBLIC_SERVER === "production";

const isOnServer = () => typeof window === "undefined" || !process.browser;

const isInBrowser = () => !isOnServer();

const isAtJgntUrl = () => baseUrl().indexOf("jgnt") >= 0;

const isAtJuggernautUrl = () => !isAtJgntUrl();

const isAtWwwUrl = () => baseUrl().indexOf("www") >= 0;

// On the frontend, we have no environment variable set for BASE_URL. We get it from the window global.
// Note that on the backend, the BASE_URL here is set when an incoming request is received, and the 'context' variable for our
// Apollo server is initialized.
const baseUrl = () => {
  return isInBrowser()
    ? get(window, "location.origin", "")
    : isDevEnvironment()
    ? 'http://localhost:3000'
    : `https://${process.env.VERCEL_URL}`
};

const devEnvironmentVariables = () => ({
  APP_STORE_SECRET: process.env.APP_STORE_SECRET,

  //environment variables up until here have been moved to vercel
  ENCRYPTION_SECRET: process.env.ENCRYPTION_SECRET,

  STRIPE_PUBLIC_API_KEY: process.env.STRIPE_DEV_PUBLIC_API_KEY,
  STRIPE_SECRET_API_KEY: process.env.STRIPE_DEV_SECRET_API_KEY,
  STRIPE_ANNUAL_PLAN_ID: process.env.STRIPE_DEV_ANNUAL_PLAN_ID,
  STRIPE_MONTHLY_PLAN_ID: process.env.STRIPE_DEV_MONTHLY_PLAN_ID,
  STRIPE_MONTHLY_10_PLAN_ID: process.env.STRIPE_DEV_MONTHLY_10_PLAN_ID,
  STRIPE_STUDENT_PLAN_ID: process.env.STRIPE_DEV_STUDENT_PLAN_ID,
  STRIPE_TWO_YEAR_PLAN_ID: process.env.STRIPE_DEV_TWO_YEAR_PLAN_ID,
  STRIPE_LIFETIME_PLAN_ID: process.env.STRIPE_DEV_LIFETIME_PLAN_ID,
  STRIPE_TAX_RATE_ID: process.env.STRIPE_DEV_TAX_RATE_ID,

  PRISMA_ENDPOINT: process.env.PRISMA_DEV_ENDPOINT,
  PRISMA_SECRET: process.env.PRISMA_DEV_SECRET,

  SEGMENT_WRITE_KEY: process.env.SEGMENT_DEV_WRITE_KEY,
  SEGMENT_SERVER_WRITE_KEY: "YqqNnUVOnQNH4BXmkIpHiCU2CvbHNgth",

  EDITORS_PICKS_CATEGORY_ID: process.env.EDITORS_PICKS_CATEGORY_ID_DEV,

  MAILCHIMP_API_KEY: process.env.MAILCHIMP_API_KEY,

  MAILGUN_API_KEY: process.env.MAILGUN_API_KEY,
  MAILGUN_PUBLIC_VALIDATION_KEY: process.env.MAILGUN_PUBLIC_VALIDATION_KEY,
  MAILGUN_DOMAIN: process.env.MAILGUN_DOMAIN,

  CONTENTFUL_ACCESS_TOKEN: process.env.CONTENTFUL_DEV_ACCESS_TOKEN,
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_DEV_SPACE_ID,

  IP_STACK_API_KEY: process.env.IP_STACK_API_KEY,

  SESSION_SECRET_CURRENT: process.env.SESSION_DEV_SECRET_CURRENT,
  SESSION_SECRET_PREVIOUS: process.env.SESSION_DEV_SECRET_PREVIOUS,

  FAUNADB_SECRET: process.env.FAUNADB_DEV_SECRET,

  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,

  PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
});

const devEnvironmentAliases = () => ({
  APP_STORE_SECRET: "APP_STORE_SECRET",

  ENCRYPTION_SECRET: "ENCRYPTION_SECRET",

  STRIPE_PUBLIC_API_KEY: "STRIPE_DEV_PUBLIC_API_KEY",
  STRIPE_SECRET_API_KEY: "STRIPE_DEV_SECRET_API_KEY",
  STRIPE_ANNUAL_PLAN_ID: "STRIPE_DEV_ANNUAL_PLAN_ID",
  STRIPE_MONTHLY_PLAN_ID: "STRIPE_DEV_MONTHLY_PLAN_ID",
  STRIPE_MONTHLY_10_PLAN_ID: "STRIPE_DEV_MONTHLY_10_PLAN_ID",
  STRIPE_STUDENT_PLAN_ID: "STRIPE_DEV_STUDENT_PLAN_ID",
  STRIPE_TWO_YEAR_PLAN_ID: "STRIPE_DEV_TWO_YEAR_PLAN_ID",
  STRIPE_LIFETIME_PLAN_ID: "STRIPE_DEV_LIFETIME_PLAN_ID",
  STRIPE_TAX_RATE_ID: "STRIPE_DEV_TAX_RATE_ID",

  PRISMA_ENDPOINT: "PRISMA_DEV_ENDPOINT",
  PRISMA_SECRET: "PRISMA_DEV_SECRET",

  SEGMENT_WRITE_KEY: "SEGMENT_DEV_WRITE_KEY",

  EDITORS_PICKS_CATEGORY_ID: "EDITORS_PICKS_CATEGORY_ID_DEV",

  MAILCHIMP_API_KEY: "MAILCHIMP_API_KEY",

  MAILGUN_API_KEY: "MAILGUN_API_KEY",
  MAILGUN_PUBLIC_VALIDATION_KEY: "MAILGUN_PUBLIC_VALIDATION_KEY",
  MAILGUN_DOMAIN: "MAILGUN_DOMAIN",

  CONTENTFUL_ACCESS_TOKEN: "CONTENTFUL_DEV_ACCESS_TOKEN",
  CONTENTFUL_SPACE_ID: "CONTENTFUL_DEV_SPACE_ID",

  IP_STACK_API_KEY: "IP_STACK_API_KEY",

  SESSION_SECRET_CURRENT: "SESSION_DEV_SECRET_CURRENT",
  SESSION_SECRET_PREVIOUS: "SESSION_DEV_SECRET_PREVIOUS",

  FAUNADB_SECRET: "FAUNADB_DEV_SECRET",

  SENTRY_DSN: "NEXT_PUBLIC_SENTRY_DSN",
});

const stagingEnvironmentVariables = () => ({
  APP_STORE_SECRET: process.env.APP_STORE_SECRET,

  ENCRYPTION_SECRET: process.env.ENCRYPTION_SECRET,

  STRIPE_PUBLIC_API_KEY: process.env.STRIPE_STAGING_PUBLIC_API_KEY,
  STRIPE_SECRET_API_KEY: process.env.STRIPE_STAGING_SECRET_API_KEY,
  STRIPE_ANNUAL_PLAN_ID: process.env.STRIPE_STAGING_ANNUAL_PLAN_ID,
  STRIPE_MONTHLY_PLAN_ID: process.env.STRIPE_STAGING_MONTHLY_PLAN_ID,
  STRIPE_MONTHLY_10_PLAN_ID: process.env.STRIPE_STAGING_MONTHLY_10_PLAN_ID,
  STRIPE_STUDENT_PLAN_ID: process.env.STRIPE_STAGING_STUDENT_PLAN_ID,
  STRIPE_TWO_YEAR_PLAN_ID: process.env.STRIPE_STAGING_TWO_YEAR_PLAN_ID,
  STRIPE_LIFETIME_PLAN_ID: process.env.STRIPE_STAGING_LIFETIME_PLAN_ID,
  STRIPE_TAX_RATE_ID: process.env.STRIPE_STAGING_TAX_RATE_ID,

  PRISMA_ENDPOINT: process.env.PRISMA_STAGING_ENDPOINT,
  PRISMA_SECRET: process.env.PRISMA_STAGING_SECRET,

  SEGMENT_WRITE_KEY: process.env.SEGMENT_STAGING_WRITE_KEY,
  SEGMENT_SERVER_WRITE_KEY: "YqqNnUVOnQNH4BXmkIpHiCU2CvbHNgth",

  EDITORS_PICKS_CATEGORY_ID: process.env.EDITORS_PICKS_CATEGORY_ID_STAGING,

  MAILCHIMP_API_KEY: process.env.MAILCHIMP_API_KEY,

  MAILGUN_API_KEY: process.env.MAILGUN_API_KEY,
  MAILGUN_PUBLIC_VALIDATION_KEY: process.env.MAILGUN_PUBLIC_VALIDATION_KEY,
  MAILGUN_DOMAIN: process.env.MAILGUN_DOMAIN,

  CONTENTFUL_ACCESS_TOKEN: process.env.CONTENTFUL_STAGING_ACCESS_TOKEN,
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_STAGING_SPACE_ID,

  IP_STACK_API_KEY: process.env.IP_STACK_API_KEY,

  SESSION_SECRET_CURRENT: process.env.SESSION_STAGING_SECRET_CURRENT,
  SESSION_SECRET_PREVIOUS: process.env.SESSION_STAGING_SECRET_PREVIOUS,

  FAUNADB_SECRET: process.env.FAUNADB_STAGING_SECRET,

  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,

  PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
});

const stagingEnvironmentAliases = () => ({
  APP_STORE_SECRET: "APP_STORE_SECRET",

  ENCRYPTION_SECRET: "ENCRYPTION_SECRET",

  STRIPE_PUBLIC_API_KEY: "STRIPE_STAGING_PUBLIC_API_KEY",
  STRIPE_SECRET_API_KEY: "STRIPE_STAGING_SECRET_API_KEY",
  STRIPE_ANNUAL_PLAN_ID: "STRIPE_STAGING_ANNUAL_PLAN_ID",
  STRIPE_MONTHLY_PLAN_ID: "STRIPE_STAGING_MONTHLY_PLAN_ID",
  STRIPE_MONTHLY_10_PLAN_ID: "STRIPE_STAGING_MONTHLY_10_PLAN_ID",
  STRIPE_STUDENT_PLAN_ID: "STRIPE_STAGING_STUDENT_PLAN_ID",
  STRIPE_TWO_YEAR_PLAN_ID: "STRIPE_STAGING_TWO_YEAR_PLAN_ID",
  STRIPE_LIFETIME_PLAN_ID: "STRIPE_STAGING_LIFETIME_PLAN_ID",
  STRIPE_TAX_RATE_ID: "STRIPE_STAGING_TAX_RATE_ID",

  PRISMA_ENDPOINT: "PRISMA_STAGING_ENDPOINT",
  PRISMA_SECRET: "PRISMA_STAGING_SECRET",

  SEGMENT_WRITE_KEY: "SEGMENT_STAGING_WRITE_KEY",

  EDITORS_PICKS_CATEGORY_ID: "EDITORS_PICKS_CATEGORY_ID_STAGING",

  MAILCHIMP_API_KEY: "MAILCHIMP_API_KEY",

  MAILGUN_API_KEY: "MAILGUN_API_KEY",
  MAILGUN_PUBLIC_VALIDATION_KEY: "MAILGUN_PUBLIC_VALIDATION_KEY",
  MAILGUN_DOMAIN: "MAILGUN_DOMAIN",

  CONTENTFUL_ACCESS_TOKEN: "CONTENTFUL_STAGING_ACCESS_TOKEN",
  CONTENTFUL_SPACE_ID: "CONTENTFUL_STAGING_SPACE_ID",

  IP_STACK_API_KEY: "IP_STACK_API_KEY",

  SESSION_SECRET_CURRENT: "SESSION_STAGING_SECRET_CURRENT",
  SESSION_SECRET_PREVIOUS: "SESSION_STAGING_SECRET_PREVIOUS",

  FAUNADB_SECRET: "FAUNADB_STAGING_SECRET",

  SENTRY_DSN: "NEXT_PUBLIC_SENTRY_DSN",
});

const productionEnvironmentVariables = () => ({
  APP_STORE_SECRET: process.env.APP_STORE_SECRET,

  ENCRYPTION_SECRET: process.env.ENCRYPTION_SECRET,

  STRIPE_PUBLIC_API_KEY: process.env.STRIPE_PRODUCTION_PUBLIC_API_KEY,
  STRIPE_SECRET_API_KEY: process.env.STRIPE_PRODUCTION_SECRET_API_KEY,
  STRIPE_ANNUAL_PLAN_ID: process.env.STRIPE_PRODUCTION_ANNUAL_PLAN_ID,
  STRIPE_MONTHLY_PLAN_ID: process.env.STRIPE_PRODUCTION_MONTHLY_PLAN_ID,
  STRIPE_MONTHLY_10_PLAN_ID: process.env.STRIPE_PRODUCTION_MONTHLY_10_PLAN_ID,
  STRIPE_STUDENT_PLAN_ID: process.env.STRIPE_PRODUCTION_STUDENT_PLAN_ID,
  STRIPE_TWO_YEAR_PLAN_ID: process.env.STRIPE_PRODUCTION_TWO_YEAR_PLAN_ID,
  STRIPE_LIFETIME_PLAN_ID: process.env.STRIPE_PRODUCTION_LIFETIME_PLAN_ID,
  STRIPE_TAX_RATE_ID: process.env.STRIPE_PRODUCTION_TAX_RATE_ID,

  PRISMA_ENDPOINT: process.env.PRISMA_PRODUCTION_ENDPOINT,
  PRISMA_SECRET: process.env.PRISMA_PRODUCTION_SECRET,

  SEGMENT_WRITE_KEY: "k5jyws9ZCbsWjZoa5il4q1cLBdQf6mdI",
  SEGMENT_SERVER_WRITE_KEY: "kVT1tv8QMijRt1NaB7Dm5bHkyaVrvsnX",

  EDITORS_PICKS_CATEGORY_ID: process.env.EDITORS_PICKS_CATEGORY_ID_PRODUCTION,

  MAILCHIMP_API_KEY: process.env.MAILCHIMP_API_KEY,

  MAILGUN_API_KEY: process.env.MAILGUN_API_KEY,
  MAILGUN_PUBLIC_VALIDATION_KEY: process.env.MAILGUN_PUBLIC_VALIDATION_KEY,
  MAILGUN_DOMAIN: process.env.MAILGUN_DOMAIN,

  CONTENTFUL_ACCESS_TOKEN: process.env.CONTENTFUL_PRODUCTION_ACCESS_TOKEN,
  CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_PRODUCTION_SPACE_ID,

  IP_STACK_API_KEY: process.env.IP_STACK_API_KEY,

  SESSION_SECRET_CURRENT: process.env.SESSION_PRODUCTION_SECRET_CURRENT,
  SESSION_SECRET_PREVIOUS: process.env.SESSION_PRODUCTION_SECRET_PREVIOUS,

  FAUNA_DB_SECRET: process.env.FAUNADB_PRODUCTION_SECRET,

  SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,

  PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
});

const productionEnvironmentAliases = () => ({
  APP_STORE_SECRET: "APP_STORE_SECRET",

  ENCRYPTION_SECRET: "ENCRYPTION_SECRET",

  STRIPE_PUBLIC_API_KEY: "STRIPE_PRODUCTION_PUBLIC_API_KEY",
  STRIPE_SECRET_API_KEY: "STRIPE_PRODUCTION_SECRET_API_KEY",
  STRIPE_ANNUAL_PLAN_ID: "STRIPE_PRODUCTION_ANNUAL_PLAN_ID",
  STRIPE_MONTHLY_PLAN_ID: "STRIPE_PRODUCTION_MONTHLY_PLAN_ID",
  STRIPE_MONTHLY_10_PLAN_ID: "STRIPE_PRODUCTION_MONTHLY_10_PLAN_ID",
  STRIPE_STUDENT_PLAN_ID: "STRIPE_PRODUCTION_STUDENT_PLAN_ID",
  STRIPE_TWO_YEAR_PLAN_ID: "STRIPE_PRODUCTION_TWO_YEAR_PLAN_ID",
  STRIPE_LIFETIME_PLAN_ID: "STRIPE_PRODUCTION_LIFETIME_PLAN_ID",
  STRIPE_TAX_RATE_ID: "STRIPE_PRODUCTION_TAX_RATE_ID",

  PRISMA_ENDPOINT: "PRISMA_PRODUCTION_ENDPOINT",
  PRISMA_SECRET: "PRISMA_PRODUCTION_SECRET",

  SEGMENT_WRITE_KEY: "SEGMENT_PRODUCTION_WRITE_KEY",

  EDITORS_PICKS_CATEGORY_ID: "EDITORS_PICKS_CATEGORY_ID_PRODUCTION",

  MAILCHIMP_API_KEY: "MAILCHIMP_API_KEY",

  MAILGUN_API_KEY: "MAILGUN_API_KEY",
  MAILGUN_PUBLIC_VALIDATION_KEY: "MAILGUN_PUBLIC_VALIDATION_KEY",
  MAILGUN_DOMAIN: "MAILGUN_DOMAIN",

  CONTENTFUL_ACCESS_TOKEN: "CONTENTFUL_PRODUCTION_ACCESS_TOKEN",
  CONTENTFUL_SPACE_ID: "CONTENTFUL_PRODUCTION_SPACE_ID",

  IP_STACK_API_KEY: "IP_STACK_API_KEY",

  SESSION_SECRET_CURRENT: "SESSION_PRODUCTION_SECRET_CURRENT",
  SESSION_SECRET_PREVIOUS: "SESSION_PRODUCTION_SECRET_PREVIOUS",

  FAUNA_DB_SECRET: "FAUNADB_PRODUCTION_SECRET",

  SENTRY_DSN: "NEXT_PUBLIC_SENTRY_DSN",
});

module.exports = {
  baseUrl,
  isAtWwwUrl,
  isAtJgntUrl,
  isAtJuggernautUrl,
  isOnServer,
  isInBrowser,
  environmentVariables,
  environmentAliases,
  isDevEnvironment,
  isStagingEnvironment,
  isProductionEnvironment,
  devEnvironmentVariables,
  devEnvironmentAliases,
  stagingEnvironmentVariables,
  stagingEnvironmentAliases,
  productionEnvironmentVariables,
  productionEnvironmentAliases,
};
